import firestore from '../firestore'
import Vue from 'vue'

export const addRootChild = ({ commit, state }, { childId, index = -1 }) => {
  let clone = {} // Object.assign({}, state.currentUser)
  // delete clone['uid']
  // delete clone['username']
  clone.rootItems = state.currentUser.rootItems || []
  if (index < 0 || index > clone.rootItems.length) {
    clone.rootItems.push(childId)
  } else {
    clone.rootItems.splice(index, 0, childId)
  }
  firestore.userDocRef.set(clone, { merge: true })
}

// Mostly used for re-ordering..
export const updateRootChildren = ({ commit, state }, newRootChildren) => {
  let clone = {}
  // let clone = Object.assign({}, state.currentUser)
  // delete clone['uid']
  // delete clone['username']
  clone.rootItems = newRootChildren
  firestore.userDocRef.set(clone, { merge: true })
}

export const updateCurrentUser = ({ state }) => {
  let clone = Object.assign({}, state.currentUser)
  delete clone['uid']
  delete clone['username']
  firestore.userDocRef.set(clone, { merge: true })
}

/**
 *
 * @param state
 * @param data  {*}
 * @param data.index  {number}
 * @param data.session.name {string}
 * @param data.session.expandedTreeNoteIds  [{string}]
 * @param data.session.rootNoteId {string|null}
 * @param data.session.spaceId  {string|null}
 */
export const updateUserSession = ({ state }, data) => {
  let sessions = state.currentUser.sessions || []
  if (sessions[data.index] === undefined) throw new Error('That user session does not exist')
  sessions[data.index] = data.session
  firestore.userDocRef.set({ sessions: sessions }, { merge: true })
}

/**
 *
 * @param state
 * @param session  {*}
 * @param session.name {string}
 * @param session.expandedTreeNoteIds  [{string}]
 * @param session.rootNoteId {string|null}
 * @param session.spaceId  {string|null}
 */
export const addUserSession = ({ state }, session) => {
  let sessions = state.currentUser.sessions || []
  sessions.push(session)
  return firestore.userDocRef.set({ sessions: sessions }, { merge: true }).then(() => {
    return state.currentUser.sessions.length - 1
  })
}

/**
 *
 * @param indexToDelete {number}  the index to delete
 */
export const deleteUserSession = ({ state }, indexToDelete) => {
  let sessions = state.currentUser.sessions || []
  if (sessions[indexToDelete] === undefined) throw new Error('That user session does not exist.')
  Vue.delete(sessions, indexToDelete)
  firestore.userDocRef.set({ sessions: sessions }, { merge: true })
}

export const openSettingsDialog = ({ commit }, searchTerm) => {
  if (!searchTerm) searchTerm = ''
  commit('setSettingsSearchTerm', searchTerm)
  commit('setSettingsOpen', true)
  return Promise.all([])
}

export const openSearchDialog = ({ commit }, searchTerm) => {
  if (searchTerm) commit('setSearchTerm', searchTerm)
  commit('setSearchOpen', true)
  return Promise.all([])
}

export const openReorderModal = ({ commit }, itemId) => {
  if (!itemId) itemId = null
  commit('setReorderModalItemId', itemId)
  commit('setReorderModalOpen', true)
  return Promise.all([])
}
